export const useStyles = (theme) => ({
  root: {
    padding: 10,
  },
  gridContainer: {
    display: "flex",
    justifyContent: "center",
  },
  gridItem: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
    },
  },
  bookItem: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  bookCoverStyle: {
    display: "flex",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.6,
    },
  },
  coverImageStyle: {
    width: 200,
    height: 260,
    [theme.breakpoints.down("sm")]: {
      width: 250,
      height: 350,
    },
  },
  bookBody: {
    width: "100%",
    paddingLeft: 20,
    paddingTop: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
});
